import { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
  Button,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Link} from "react-router-dom";

const FAQ = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqData = [
    {
      id: "panel1",
      question: "What is f-ai?",
      answer:
        "Designed for companies of all sizes, f-ai is an AI-powered accounting assistant that automates financial tasks, classification, reporting, and more.",
    },
    {
      id: "panel2",
      question: "How does an AI accounting assistant work?",
      answer:
        "AI accounting assistant software automates tasks like data entry and transaction sorting by learning from your financial activity, saving time and reducing errors.",
    },
    {
      id: "panel3",
      question: "How can an AI accounting assistant help your business?",
      answer:
        "An AI accounting assistant automates data entry, categorizes transactions, generates real-time reports, and reduces errors saving time, improving accuracy, and helping you make smarter financial decisions.",
    },
    {
      id: "panel4",
      question: "How can AI be integrated into accounting processes?",
      answer:
        "AI can be integrated by automating tasks like data entry, expense categorization, invoice processing, bank reconciliations, and report generation streamlining workflows and reducing manual effort.",
    },
    {
      id: "panel5",
      question: "Is f-ai truly an AI accounting assistant?",
      answer:
        "Yes, it’s built entirely around AI and automation, making it a fully‑fledged AI accounting assistant that learns and scales with you.",
    },
    {
      id: "panel6",
      question: "Is an AI accounting assistant suitable for small businesses?",
      answer:
        "Absolutely. AI software is especially useful for small businesses with limited accounting resources.",
    },
    {
      id: "panel7",
      question:
        "What is the difference between AI accounting and traditional software?",
      answer:
        "AI software learns and improves over time, automates more tasks, offers predictive insights, and requires less manual intervention than traditional tools.",
    },
    {
      id: "panel8",
      question:
        "Can an AI accounting assistant handle multiple users or teams?",
      answer:
        "Yes, many AI accounting tools like f-ai are scalable and support multi-user access with permission control.",
    },
    {
      id: "panel9",
      question: "Is AI accounting assistant software scalable?",
      answer:
        "Yes, AI accounting assistant software is scalable. It can adapt to growing business needs by supporting more users, handling larger transaction volumes, integrating with other systems, and automating complex workflows as your business expands.",
    },
    {
      id: "panel10",
      question: "Can I chat or talk to an AI accounting assistant?",
      answer:
        "Many AI tools, including ours, offer chatbot or voice interfaces, allowing users to ask questions, generate reports, and get insights hands-free.",
    },
  ];

  return (
    <Box sx={{ bgcolor: "grey.50", py: 8 }}>
      <Container maxWidth="md">
        {/* Header section */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h4"
            component="h2"
            fontWeight="bold"
            gutterBottom
          >
            Frequently Asked Questions
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Find answers to the most common questions about f-ai.
          </Typography>
        </Box>

        <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
          {faqData.map((item) => (
            <Accordion
              key={item.id}
              expanded={expanded === item.id}
              onChange={handleChange(item.id)}
              elevation={0}
              square
              sx={{
                "&:before": { display: "none" },
                "&:not(:last-child)": {
                  borderBottom: 1,
                  borderColor: "divider",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${item.id}-content`}
                id={`${item.id}-header`}
                sx={{ py: 1 }}
              >
                <Typography variant="subtitle1" fontWeight="medium">
                  {item.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography color="text.secondary">{item.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>

        <Paper
          elevation={0}
          sx={{
            mt: 6,
            p: 4,
            textAlign: "center",
            bgcolor: "primary.lightest",
            backgroundColor: "#eef2ff",
            borderRadius: 2,
          }}
        >
          <Typography variant="h5" component="h3" fontWeight="bold">
            Still have questions?
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1, mb: 3 }}>
            Can't find the answer you're looking for? Please chat with our
            friendly team.
          </Typography>
          <Button
            component={Link}
            to="/Contactus"
            variant="contained"
            size="large"
            sx={{ textTransform: "none" }}
          >
            Get in touch
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default FAQ;
